<template>
    <Select v-model="equipId" clearable filterable remote :remote-method="loadEquip" :loading="loading"
            @on-change="handleChange" :label="defaultTxt" :placeholder="placeholder">
        <Option v-for="(option, index) in list" :value="option.id" :key="index">{{option.plateNo}}</Option>
    </Select>
</template>

<script>
    import iEquip from '@/module/main/api/iEquip';

    export default {
        name: "equip-search",
        props: {
            value: {
                type: Number,
                default: null
            },
            placeholder: {
                type: String,
                default:'车牌号'
            }
        },
        data() {
            return {
                equipId: '',
                loading: false,
                defaultTxt: null,
                list: [],
            }
        },
        mounted() {
        },
        watch: {
            value(val) {
                if (val) {
                    this.init();
                }
            }
        },
        methods: {
            init() {
                iEquip.equipSearch({id:this.value}).then(res => {
                    this.list = res;
                    if(res.length>0){
                        this.equipId = this.list[0].id
                        // this.defaultTxt = this.list[0].plateNo
                    }
                })
            },
            loadEquip(query) {
                if (query) {
                    iEquip.equipSearch({plateNo:query}).then(res => {
                        this.list = res;
                    })
                }
            },
            handleChange(val) {
                this.$emit('input', val);
                this.$emit('on-change', val);
            }
        }
    }
</script>
